import * as React from 'react'
import { Link } from 'react-router-dom'
import { logout, getFavoriteList, getFavoriteListSuccess } from './actions'
import { fetchedReports } from './../../scenes/Article/actions'
import { getArticleDetail, getArticleDetailSuccess } from './../../scenes/ArticleDetail/actions'
import { updateFavoriteArticle } from '../../actions'
import { connect } from 'react-redux'
import Logo from '../Logo'
import './Header.css'
import history from '../../history'

import {
    fetchQuery,
} from '../SearchInput/actions'
class Header extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            showMenu: false,
            favoritesState: 'hide-favorite',
            focusMask: false,
            enableClose: 0,
        }
        this.showFavorite = this.showFavorite.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.hideFavorite = this.hideFavorite.bind(this)
    }
    componentDidMount() {
        document.onclick = this.hideFavorite;
    }
    handleLogout = () => {
        this.setState({
            showMenu: false,
            currentTab: 0,
            favoritesState: 'hide-favorite',
        })
        this.props.logout()
    }

    toggleMenu = () => {
        this.setState({
            showMenu: !this.state.showMenu
        })
    }
    hideFavorite = () => {
        this.setState(
            {
                enableClose: this.state.enableClose + 1
            }
        )
        if (this.state.favoritesState === 'favorite-box' && this.state.enableClose % 2 === 0) {
            this.setState({
                favoritesState: 'hide-favorite',
            })
        } else if (this.state.favoritesState === 'hide-favorite') {
            this.setState(
                {
                    enableClose: 0
                }
            )
        }
    }

    showFavorite = (e: any) => {
        e.nativeEvent.stopImmediatePropagation();
        if (this.state.favoritesState === 'hide-favorite') {
            this.props.getFavoriteList()
            let newFavoriteList = this.props.favoriteList.entities
            this.props.getFavoriteListSuccess(newFavoriteList)

            this.setState(
                {
                    favoritesState: 'favorite-box'
                }
            )
        } else {
            this.setState(
                {
                    favoritesState: 'hide-favorite'
                }
            )
        }
    }

    handleDelete = (index: number) => {
        let data = {
            action: 'delete',
            favorites_list: this.props.favoriteList.entities[index].id
        }
        this.props.updateFavoriteArticle(
            data
        )
        let newFavoriteList = this.props.favoriteList.entities
        let newReports = this.props.reports.entities
        this.props.getFavoriteListSuccess(newFavoriteList)
        for (let i = 0; i < this.props.reports.entities.length; i++) {
           if (this.props.favoriteList.entities[index].id === this.props.reports.entities[i].report_id) {
               newReports[i].enable_favorites = !this.props.reports.entities[i].enable_favorites
           }
        }
        this.props.fetchedReports(newReports)
        const newDetail = {
            ...this.props.detail.entities,
            enable_favorites: false
        }
        this.props.fetchedArticleDetail(newDetail)
        newFavoriteList.splice(index, 1)
    }
    goToDetail(id: any) {
        this.props.getArticleDetail(id)
    }
    setBackgroundMask() {
        this.setState(
            {
                focusMask: true
            }
        )
    }
    hideMask() {
        this.setState(
            {
                focusMask: false
            }
        )
    }

    goToSearch(input: any) {
        sessionStorage.setItem('input', input)
        if (location.pathname.split('/').indexOf('search')) {
            const query = {'query_string': input, 'page': 0}
            this.props.fetchQuery(query)
        }
        const url = '/search/' + input
        history.push(url)
        this.hideMask()
    }

    render() {
        const hasToken = this.props.token ? true : false
        const email = this.props.user.entities.email
        const favoriteList = this.props.favoriteList.entities
        const focusMask = this.state.focusMask
        // const loactions = ['/', '/login', '/register']
        return (
            <div className="header">
                {
                    focusMask ?
                        <div className="focus-background"/>
                        :
                        ''
                }
                <div className="header-container">
                    <Logo/>
                    <div className={'menu ' + (this.state.showMenu ? 'show-menu' : 'hide-menu')}>
                        <ul className="main-nav"/>
                        <div className="user-nav">
                            {
                                hasToken ?
                                    <ul>
                                        <li><a>{email}</a></li>
                                        <li><Link to="/article">报告订阅</Link></li>
                                        <li onClick={this.showFavorite} onBlur={this.hideFavorite}><a>我的收藏</a></li>
                                        <li><a onClick={() => {this.handleLogout()}}>退出登录</a></li>
                                    </ul> :
                                    <ul>
                                        <li><Link to="/login">登录</Link></li>
                                        <li><Link to="/register">注册</Link></li>
                                    </ul>
                            }
                        </div>
                    </div>
                    <div className="mobile-menu-icon" onClick={() => this.toggleMenu()}>
                        <p><i className="fa fa-bars"/></p>
                    </div>
                    {
                        favoriteList && favoriteList.length > 0 ?
                            <div className={this.state.favoritesState}>
                                {
                                    favoriteList.map((item: any, index: number) =>
                                        <div className="favorite-list" key={item.id}>
                                            <div className="title">
                                                <Link to={`/article/${item.id}`}>{item.title}</Link>
                                            </div>
                                            <div className="delete" onClick={() => this.handleDelete(index)}>x
                                            </div>
                                        </div>)
                                }
                            </div>
                            : ''
                    }
                    {
                        this.state.showMenu &&
                        <div className="menu-overlay" onClick={() => this.toggleMenu()}/>
                    }
                    {
                        favoriteList && favoriteList.length > 0 ?
                            <div className={this.state.favoritesState}>
                                {
                                    favoriteList.map((item: any, index: number) =>
                                        <div className="favorite-list" key={item.id}>
                                            <div className="title" onClick={() => this.goToDetail(item.id)}>
                                                <Link to={`/article/${item.id}`}>{item.title}</Link>
                                            </div>
                                            <div className="delete" onClick={() => this.handleDelete(index)}>x
                                            </div>
                                        </div>)
                                }
                            </div>
                            : ''
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        token: state.fetchedToken,
        user: state.user,
        reports: state.reports,
        detail: state.articleDetail,
        isLoggingOut: state.isLoggingOut,
        hasLoggedOut: state.hasLoggedOut,
        favoriteList: state.favoriteList
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        logout: () => dispatch(logout()),
        getFavoriteList: () => dispatch(getFavoriteList()),
        fetchedReports: (data: object) => dispatch(fetchedReports(data)),
        getArticleDetail: (data: object) => dispatch(getArticleDetail(data)),
        fetchedArticleDetail: (data: object) => dispatch(getArticleDetailSuccess(data)),
        getFavoriteListSuccess: (data: object) => dispatch(getFavoriteListSuccess(data)),
        updateFavoriteArticle: (data: object) => dispatch(updateFavoriteArticle(data)),
        fetchQuery: (data: object) => dispatch(fetchQuery(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Header/index.tsx